<div *ngIf="loading" class="loading-text">
  <p>{{ 'PleaseWaitDataLoading' | translate }}</p>
</div>

<div *ngIf="!loading">
  <app-sub-header [pageTitle]="'Services' | translate"></app-sub-header>

  <div class="padded-container">
      <div *ngIf="servicesListResponse?.services">
          <div *ngFor="let serviceItem of servicesListResponse?.services">
              <dx-button
                  class="full-width-button"
                  (click)="continueNextStep(serviceItem.id)"
                  type="default">
                  {{ serviceItem.description }}
              </dx-button>
          </div>

  <dx-button
      class="full-width-button"
      type="danger"
      (click)="navigateToServicePickCar()">
      {{ 'Back' | translate }}
  </dx-button>
</div>
</div>